import { render, staticRenderFns } from "./DonutChart68.vue?vue&type=template&id=490bc83b&scoped=true&"
import script from "./DonutChart68.vue?vue&type=script&lang=js&"
export * from "./DonutChart68.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490bc83b",
  null
  
)

export default component.exports